module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-mlk-left-4e219a5e25bf9b8c5aaede9c9206ab79.svg";